const publishHelpEvent = (name, detail) => {
  try {
    if (!globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    globalThis.Shopify?.analytics?.publish?.(name, detail)?.catch?.(() => {});
  } catch {}
};
class OZBagFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const select = this.querySelector('select');
    const cards = [...this.querySelectorAll('[data-bag-type]')];
    const status = this.querySelector('[data-bag-status]');
    if (!select || !status) return;
    const update = () => {
      let count = 0;
      for (const card of cards) {
        card.hidden = Boolean(select.value && card.dataset.bagType !== select.value);
        if (!card.hidden) count++;
      }
      status.textContent = `${count} ${count === 1 ? 'bag type' : 'bag types'} shown`;
    };
    select.addEventListener('change', () => {
      update();
      publishHelpEvent('shop_bag_type_selected', { tool: 'oz_bag_finder', bag_type: select.value || 'all' });
    });
    update();
  }
}
if (!customElements.get('oz-bag-finder')) customElements.define('oz-bag-finder', OZBagFinder);
document.addEventListener('click', event => {
  const link = event.target?.closest?.('a[data-oz-help]');
  if (link) publishHelpEvent('shop_product_help_clicked', { tool: link.dataset.ozHelp });
});
